import { FC, memo } from 'react'
import { Layer } from '@cargomart/ui'
import { Overlay } from 'components/extend/Overlay'
import { TransitionFade } from 'components/extend/Transition'
import { useTypedSelector } from 'hooks/useTypedSelector'

import { Sidebar } from './Sidebar'
import { ModalSidebarProps } from './types'

import s from './ModalSidebar.module.less'

const ModalSidebar: FC<ModalSidebarProps> = (props) => {
  const { isModalNotifications, notificationNotViewed, handleOpenModalNotifications } = props
  const { isOpenMobileSidebar } = useTypedSelector((state) => state.globalReducer)

  return (
    <>
      <TransitionFade in={isOpenMobileSidebar}>
        <Overlay />
      </TransitionFade>
      <TransitionFade in={isOpenMobileSidebar}>
        <Layer>
          <div className={s.ModalSidebar}>
            <Sidebar
              handleOpenModalNotifications={handleOpenModalNotifications}
              isModalNotifications={isModalNotifications}
              notificationNotViewed={notificationNotViewed}
            />
          </div>
        </Layer>
      </TransitionFade>
    </>
  )
}

export default memo(ModalSidebar)
